import { SelectModelPage } from '../containers/selectModelPage';
import { TechDocChecklistPage, TechDocWizardPage, TechDocPage } from '../containers/pages';
import { ALLETRAMP_VIDEO_URL } from '../constants';
const gettingStartedPath = '/getting-started/';
const cloudEnablementPath = `${gettingStartedPath}cloud-enablement/`;
export const gettingStarted = () => {
  let config = [];
  config = gettingStartedConfig();
  return config;
};
function gettingStartedConfig() {
  const menuItemArray = [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectStorageTier',
          pageName: 'selectStorageTier',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
            ],
          },
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallation',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
    {
      path: '/physical-install',
      menuText: 'physicalInstallation',
      exact: true,
      redirectTo: '/physical-install/installbrackets',
      submenuItems: [
        {
          path: '/physical-install/installbrackets',
          menuText: 'installBrackets',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/physical-install/installserver',
          menuText: 'installServer',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/physical-install/cable',
          menuText: 'cableSimplivity',
          exact: true,
          redirectTo: '/physical-install/cable/1',
        },
        {
          path: '/physical-install/cable/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cableSimplivity',
          pageProps: {
            steps: [
              {
                videoUrl_green: '',
                steptitle: 'Connect Power Cables',
              },
              {
                videoUrl_green: '',
                steptitle: 'Connect Network Cables',
              },
              {
                videoUrl_green: '',
                steptitle: 'Organize Cables',
              },
            ],
          },
        },
        {
          path: '/physical-install/powerOn',
          menuText: 'powerOnSimplivity',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
      ],
    },
    {
      path: '/software-config',
      menuText: 'softwareConfig',
      exact: true,
      redirectTo: '/software-config/configureiloport',
      submenuItems: [
        {
          path: '/software-config/configureiloport',
          menuText: 'ConfigureIloPort',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connecttoilo',
          menuText: 'ConnectToIlo',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connecttovcenter',
          menuText: 'ConnectToVcenter',
          exact: true,
          redirectTo: '/software-config/connecttovcenter/1',
        },
        {
          path: '/software-config/connecttovcenter/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'ConnectToVcenter',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Download OVA',
              },
              {
                videoUrl: '',
                steptitle: 'Deploy Data Services Connector',
              },
              {
                videoUrl: '',
                steptitle: 'Configure Data Services Connector',
              },
              {
                videoUrl: '',
                steptitle: 'Activate Data Services Connector',
              },
              {
                videoUrl: '',
                steptitle: 'Register vCenter',
              },
            ],
          },
        },
        {
          path: '/software-config/completeSetup',
          menuText: 'setupComplete',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
      ],
    },
  ];
  return menuItemArray;
}
